module.exports = __webpack_public_path__ + "static/media/LWT.13cee411.webp";